<div class="modal">
  <div class="modal__content">
    <div class="window">
      <i class="window__close icon-close" (click)="modal.close()"></i>
      <form class="form" [formGroup]="form" (ngSubmit)="submit()">
        <div class="form__top">
          <div class="form__title">{{ info?.title | translate }}</div>
          <div class="form__description">{{ info?.description | translate }}</div>
        </div>
        <div class="input-container">
          <app-form-input class="input-item" [errors]="periodErrors" [control]="form.get('period')">
            @if (limit.type === Type.SESSION) {
              <div class="form__label">{{ 't.period' | translate }}</div>
              <input class="input input--simple" type="number" name="period" formControlName="period">
            }
            @if (limit.type === Type.COOLINGOFF) {
              <div class="form__label">{{ 't.period' | translate }}</div>
              <app-select class="select reality-check" formControlName="period">
                <app-select-header class="select__header">{{'t.select-period' | translate}}</app-select-header>
                <app-select-dropdown class="select__dropdown">
                  @for (value of values[Type.COOLINGOFF]; track value) {
                    <app-select-option class="select__option"
                      [value]="value.value">
                      {{ value.message | translate }}
                    </app-select-option>
                  }
                </app-select-dropdown>
              </app-select>
            }
          </app-form-input>
        </div>
        <div class="form__actions">
          @if (limit.status === Status.ACTIVE) {
            <button type="button" (click)="cancelLimit()" class="btn small cancel">
              {{'btn.cancel' | translate}}
            </button>
          }
          <button type="submit" class="btn small">
            {{'t.apply' | translate}}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
